import { createSelector } from 'reselect';
import { StoreState } from '../store-interfaces';

export const selectContacts = (state: StoreState) => state.contacts;

const getContactsByAudienceIdMap = (state: StoreState) =>
  state.contactsByAudienceId.records;

export const selectInvalidAudienceContactRecordsIds = (state: StoreState) =>
  Object.entries(state.contactsByAudienceId.invalidRecords)
    .filter(([_, isInvalid]) => isInvalid)
    .map(([id]) => Number(id));

export const selectContactsByAudienceId = createSelector(
  [
    getContactsByAudienceIdMap,
    selectInvalidAudienceContactRecordsIds,
    (_, id: number | undefined) => id,
  ],
  (contactsByAudienceId, invalidAudienceContactRecordsIds, id) =>
    id && !invalidAudienceContactRecordsIds.includes(id)
      ? contactsByAudienceId[id]
      : undefined,
);
